import { render, staticRenderFns } from "./ToastPanel.vue?vue&type=template&id=47ed1740&"
import script from "./ToastPanel.vue?vue&type=script&lang=js&"
export * from "./ToastPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports